export default "__VITE_ASSET__OCmrlB5S__"